import { render, staticRenderFns } from "./PrivatePurchaseKey4g.vue?vue&type=template&id=ac0d4770&scoped=true&"
import script from "./PrivatePurchaseKey4g.vue?vue&type=script&lang=js&"
export * from "./PrivatePurchaseKey4g.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePurchaseKey4g.vue?vue&type=style&index=0&id=ac0d4770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0d4770",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac0d4770')) {
      api.createRecord('ac0d4770', component.options)
    } else {
      api.reload('ac0d4770', component.options)
    }
    module.hot.accept("./PrivatePurchaseKey4g.vue?vue&type=template&id=ac0d4770&scoped=true&", function () {
      api.rerender('ac0d4770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivatePurchaseKey4g.vue"
export default component.exports